import { render, staticRenderFns } from "./EsNoTenant.vue?vue&type=template&id=15ef266c&scoped=true&"
import script from "./EsNoTenant.vue?vue&type=script&lang=ts&"
export * from "./EsNoTenant.vue?vue&type=script&lang=ts&"
import style0 from "./EsNoTenant.vue?vue&type=style&index=0&id=15ef266c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef266c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsCreateButton: require('/app/src/components/common/EsCreateButton.vue').default})
